module.exports = __webpack_public_path__ + "static/media/BoundWorx_Maintenance.942456a6.pdf";